import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import queryString from "query-string";
import InputField from "../../../components/forms/InputField";
import { setNewPasswordAction } from "../../../redux/actions/accountRecovery.actions";
import { validatePassword } from "../../../services/validation";

class ResetPasswordPage extends Component {
  handleSetPasswordByEmail = password => {
    const { token } = queryString.parse(this.props.location.search);
    this.props.setNewPasswordAction({ password, token });
  };
  handleSetPasswordByCode = password => {
    this.props.setNewPasswordAction({
      password,
      user: this.props.selectedAccount.user
    });
  };

  handleSetPassword = ({ password }) => {
    if (this.props.recoveryMethod === "text") {
      this.handleSetPasswordByCode(password);
    } else {
      this.handleSetPasswordByEmail(password);
    }
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center"
      >
        <div className="col-lg-4 text-center">
          <h3 id="sign-in-brand">Set New Password</h3>
          <br />

          <div className="row align-items-center justify-content-center">
            <div className="col-lg-6 text-center">
              <form onSubmit={handleSubmit(this.handleSetPassword)}>
                <Field
                  label="New Password"
                  hideLabel={true}
                  name="password"
                  type="password"
                  id="new-password-input"
                  textAlign="center"
                  component={InputField}
                  placeholder="New Password"
                />
                <br />
                <Field
                  label="Confirm New Password"
                  hideLabel={true}
                  name="confirmNewPassword"
                  type="password"
                  id="confirm-new-password-input"
                  textAlign="center"
                  component={InputField}
                  placeholder="Confirm New Password"
                />
                <br />
                <button type="submit" className="btn btn-primary btn-block">
                  Set Password
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};

  const passwordErrors = validatePassword(values.password);

  if (values.password !== values.confirmNewPassword) {
    errors.confirmNewPassword = "Passwords do not match";
  }

  return { ...errors, ...passwordErrors };
};

const mapStateToProps = ({ accountRecovery }) => ({
  selectedAccount: accountRecovery.selectedAccount,
  recoveryMethod: accountRecovery.recoveryMethod
});

export default reduxForm({
  validate,
  form: "ResetPasswordPageForm"
})(
  withRouter(
    connect(
      mapStateToProps,
      { setNewPasswordAction }
    )(ResetPasswordPage)
  )
);



// WEBPACK FOOTER //
// ./src/components/pages/ResetPasswordPage/ResetPasswordPage.jsx